<template>
  <div class="row">
    <div class="col-lg-12">
      <h5 class="text-primary">{{ reportType.title + ' Filtreleme Alanları' }}</h5>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="orderByValue"
          label="Sıralama"
          filled
          :items="[{value:1, text:'Borca Göre'},{value:2, text:'Alacağa Göre'},{value:3, text:'Bakiyeye Göre'}]"
          item-text="text"
          item-value="value"
          auto-se
          solo
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeStart)"
              label="Tarih Aralık Başlangıç"
              prepend-inner-icon="mdi-calendar"
              :error-messages="
                      validationMessages($v.dateRangeStart, 'Tarih Aralık Başlangıç')
                    "
              @input="$v.dateRangeStart.$touch()"
              @blur="$v.dateRangeStart.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeStart = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeStart"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <v-menu
          transition="scale-transition"
          offset-y
          :close-on-content-click="false"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              :value="formattedDate(dateRangeEnd)"
              label="Tarih Aralık Bitiş"
              prepend-inner-icon="mdi-calendar"
              :error-messages="validationMessages($v.dateRangeEnd, 'Tarih Aralık Bitiş')"
              @input="$v.dateRangeEnd.$touch()"
              @blur="$v.dateRangeEnd.$touch()"
              readonly
              filled
              solo
              dense
              clearable
              @click:clear="dateRangeEnd = null"
              v-bind="attrs"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="dateRangeEnd"
            locale="tr"
        ></v-date-picker>
      </v-menu>
    </div>
    <div class="col-lg-3">
      <search-select
          :search-type="'current'"
          @itemChange="(e) => (selectedCurrent = e)"
          :label="'Cari'"
      >
      </search-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="salesPersonCode"
          label="Plasiyer"
          filled
          solo
          dense
          :items="salesPersonList"
          :item-text="item => item.name"
          :item-value="item => item.code"
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          v-model="groupCodeValue"
          label="Grup Kodu"
          :items="groupCodeList"
          item-text="name"
          item-value="code"
          filled
          solo
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          label="Kod 1"
          v-model="groupCodeValue1"
          :items="groupCodeList1"
          item-text="name"
          item-value="code"
          filled
          solo
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          label="Kod 2"
          v-model="groupCodeValue2"
          :items="groupCodeList2"
          item-text="name"
          item-value="code"
          filled
          solo
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          label="Kod 3"
          v-model="groupCodeValue3"
          :items="groupCodeList3"
          item-text="name"
          item-value="code"
          filled
          solo
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          label="Kod 4"
          v-model="groupCodeValue4"
          :items="groupCodeList4"
          item-text="name"
          item-value="code"
          filled
          solo
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-select
          label="Kod 5"
          v-model="groupCodeValue5"
          :items="groupCodeList5"
          item-text="name"
          item-value="code"
          filled
          solo
          dense
      >

      </v-select>
    </div>
    <div class="col-lg-3">
      <v-text-field
          v-model="cityValue"
          label="İl"
          filled
          solo
          dense
      >

      </v-text-field>
    </div>
    <div class="col-lg-3">
      <v-text-field
          v-model="townValue"
          label="İlçe"
          filled
          solo
          dense
      >

      </v-text-field>
    </div>
    <div class="col-lg-3" v-if="erpSettings.userBranch">
      <v-select
          v-model="branchCodeValue"
          label="Şube Kodu"
          filled

          solo
          dense
          :items="branchList"
          item-value="code"
          item-text="name"
      >

      </v-select>
    </div>
    <div class="col-lg-12 text-end">
      <v-btn small color="primary" @click="filterReport">
        <v-icon left>mdi-filter</v-icon>
        FİLTRELE
      </v-btn>
    </div>
  </div>
</template>

<script>

import {formattedDate} from "@/momentHelper";
import {mapActions, mapMutations, mapState} from "vuex";
import {required} from "vuelidate/lib/validators";
import {validationMessages} from "@/validationMessages";
import {showProcessErrorMessage} from "@/state/alertHelpers";
import SearchSelect from "@/components/searchSelect.vue";

export default {
  name: "GenelBorcAlacak",
  components: {SearchSelect},
  props: {
    reportType: {
      type: Object,
      default: () => {
      }
    }
  },
  mounted() {
    this.getBranchList();
    this.getCodesList();
    this.fetchSalesPersonList({
      params: {},
      body: {}
    });
  },
  computed: {
    ...mapState("current", ["salesPersonList"]),
    ...mapState("auth", ["user"]),
    ...mapState("company", ['branchList']),
    ...mapState("settings", ["erpSettings"]),
  },
  data() {
    return {
      dateRangeStart: null,
      dateRangeEnd: null,
      orderByValue: 1,
      groupCodeList: [],
      groupCodeList1: [],
      groupCodeList2: [],
      groupCodeList3: [],
      groupCodeList4: [],
      groupCodeList5: [],
      groupCodeValue: null,
      groupCodeValue1: null,
      groupCodeValue2: null,
      groupCodeValue3: null,
      groupCodeValue4: null,
      groupCodeValue5: null,
      cityValue: "",
      townValue: "",
      branchCodeValue: null,
      currentCodeValue: null,
      currentSearchText: "",
      currentSearchLoading: false,
      currentSearchResult: [],
      searchCurrentTimeout: null,
      selectedCurrent: null,
      salesPersonCode: null,
    }
  },

  validations: {
    dateRangeStart: {
      required,
    },
    dateRangeEnd: {
      required,
    },
  },

  methods: {
    ...mapActions("stock", ["fetchStockList", "fetchStockCodes"]),
    ...mapActions("company", ['fetchBranchList']),
    ...mapActions("current", ['fetchCurrentList', 'fetchSalesPersonList']),
    ...mapMutations("company", ['setBranchList']),
    formattedDate,
    validationMessages,
    async getCodesList() {
      let codeList = [1, 2, 3, 4, 5, 6];
      for (let i = 0; i < codeList.length; i++) {
        let requestParams = {};
        switch (codeList[i]) {
          case null:
            requestParams.params = {};
            requestParams.body = {}
            break;
          default:
            requestParams.params = {tableType: codeList[i]};
            requestParams.body = {}
            break;
        }
        let result = await this.fetchStockCodes(requestParams);
        switch (codeList[i]) {
          case 1:
            this.groupCodeList = result;
            break;
          case 2:
            this.groupCodeList1 = result;
            break;
          case 3:
            this.groupCodeList2 = result;
            break;
          case 4:
            this.groupCodeList3 = result;
            break;
          case 5:
            this.groupCodeList4 = result;
            break;
          case 6:
            this.groupCodeList5 = result;
            break;

        }
      }
    },
    async getBranchList() {
      await this.fetchBranchList({
        params: {},
        body: {}
      });
      let tempBranchList = this.branchList.slice();
      tempBranchList.unshift({code: 0, name: 'Tüm Şubeler'})
      this.setBranchList(tempBranchList);
    },
    async _fetchCurrentList() {
      this.currentSearchResult = await this.fetchCurrentList({
        params: {
          userId: this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2 ? true : false) && {salesPersonCode: this.user.SalesPersonCode},
          ...(this.currentSearchText == "" || this.currentSearchText == null ? false : true) && {searchText: this.currentSearchText}
        },
        body: {},
        loading: false
      });
      this.currentSearchLoading = false;
    },
    filterReport() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.filterRequestObject = {
          StartDate: this.dateRangeStart,
          FinishDate: this.dateRangeEnd,
          CurrentCode: this.selectedCurrent,
          OrderBy: this.orderByValue,
          GroupCode: this.groupCodeValue,
          Code: this.groupCodeValue1,
          Code2: this.groupCodeValue2,
          Code3: this.groupCodeValue3,
          Code4: this.groupCodeValue4,
          Code5: this.groupCodeValue5,
          City: this.cityValue,
          Town: this.townValue,
          BranchCode: this.branchCodeValue,
          SalesPersonCode: this.salesPersonCode,

        };
        this.$emit("reportFilterChange", this.filterRequestObject);
      } else
        showProcessErrorMessage({
          title: 'Filtreleme Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })

    },
  },

  watch: {
    currentSearchText: function (newVal) {
      if (newVal && (newVal.length > 2)) {
        this.currentSearchResult = [];
        if (this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
        this.currentSearchLoading = true
        this.searchCurrentTimeout = setTimeout(() => {

          this._fetchCurrentList();

        }, 2000);
      }
    }
  }
}
</script>

<style scoped>

</style>